import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  swiperWrapper: 'data-media-swiper',
  activeIndex: 'data-active-index',
}
const qsAll = {
  sections: 'data-section-type="clinical-piercing-standard"',
  cards: 'data-clinical-standard-card',
}

const initSection = (section) => {
  const cards = section.querySelectorAll(`[${qsAll.cards}]`)
  const container = section.querySelector(`[${qs.activeIndex}]`)
  cards.forEach((card, index) => {
    card.addEventListener('mouseenter', () => {
      container.setAttribute(qs.activeIndex, index)
      cards.forEach(c => c.classList.toggle('clinical-piercing-standard--card__active', c == card))
    })
  })
}

export const setupClinicalPiercingStandard = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSection(section))
}